import Vue from "vue";

// When the request succeeds
const success = (response, context) => {
  if (response.data.twofa_hidden_phone) {
    context.user.twofa_request_id = response.data.twofa_request_id;
    context.hiddenPhone = response.data.twofa_hidden_phone;
    context.twoFaByEmailModeEnabled = false;
  }

  if (response.data.twofa_hidden_email) {
    context.hiddenEmail = response.data.twofa_hidden_email;
    context.twoFaByEmailModeEnabled = true;
  }

  context.smallLoading = false;
  context.openregister2faModal();
};

// When the request fails
const failed = (context, error) => {
  if (
    error.response.data.msg ===
    "Vous avez déjà reçu un code de confirmation sur votre boîte mail. Merci de vérifier vos spams."
  ) {
    context.twoFaByEmailModeEnabled = true;
  }
  context.smallLoading = false;
  context.showToasterError(error);
  if (
    error.response.data.msg !==
    "L'adresse email ou le mot de passe que vous avez entré est incorrect."
  ) {
    context.openregister2faModal();
  }
};

export default (user, context) => {
  Vue.$http
    .post("/user/login-for-web-app", user)
    .then((response) => {
      if (typeof response === "undefined") {
        failed(context);
      } else {
        if (response.status === 201) {
          success(response, context);
        } else {
          failed(context, response.data.msg);
        }
      }
    })
    .catch((error) => {
      if (error) {
        failed(context, error);
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/services/auth/loginWith2fa.js